import axios from "axios";
import store from "../store";

class ClienteService {

    async getRotaEntrega() {
        return await axios.get("cliente/rota_entrega")
    }

    async getCredito() {
        return await axios.get("cliente/credito")
    }

    buscarTodos() {
        return axios.get("cliente/all");
    }

    buscarPorId(clienteId: number) {
        return axios.get(`cliente/id/${clienteId}`);
    }

    buscarSetTodos(data: { paginacao: any; filtro: { searchStr: string } }) {
        return axios.get("cliente/all", { headers: { 'pagination': JSON.stringify(data.paginacao), 'filter': JSON.stringify(data.filtro) } });
    }

    buscarGrupoProdutosCliente(clienteId: number) {
        return axios.get(`produto/grupos/cliente/${clienteId}`);
    }

    alterarGrupoProdutosCliente(cliente: any) {
        return axios.put("cliente/grupos_produtos/update", cliente);
    }

    buscarSitFinanc() {
        return axios.get("cliente/sitfinanc");
    }

    async buscarClientesPorId(ids: number[]) {
        try {
            const promises = ids.map(id => this.buscarPorId(id))
            const responses = await Promise.all(promises)
            return {
                data: responses.map(r => r.data)
            }
        } catch (error) {
            console.error('Erro ao buscar clientes por IDs:', error)
            throw error
        }
    }

}

export default new ClienteService();